import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
import { normalizeEnterpriseOrganization } from '#pplx/frontend/user-info/enterpriseResponse.js';
import { webserveruserClient } from '#pplx_generated/typespec/rest/webserveruser/client.js';
// Scoped variants remain descendants so organization mutations invalidate them too.
export const getUserOrganizationQueryKey = (...scope) => QueryClientHelper.makeQueryKey('/rest/enterprise/user/organization', ...scope);
export const getUserOrganizationResponse = async ({ reason, }) => {
    const { data, error, response } = await webserveruserClient.GET('/rest/enterprise/user/organization', reason, {
        params: { query: { supports_invite_link_state: true } },
        timeoutMs: getQueryTimeoutMs({ productionMs: 2000 }),
        numRetries: 1,
    });
    if (error || !data || data.status !== 'success') {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            cause: error,
            status: response.status ?? 0,
            details: { reason },
        });
    }
    return {
        ...data,
        organization: data.organization ? normalizeEnterpriseOrganization(data.organization) : null,
    };
};
//# sourceMappingURL=orgInfoQueries.js.map